<template>
  <section>
    <h2 class="mb-0">{{ $t('sizeSelect.title') }}</h2>
    <h3 class="d-none d-xl-block text-dark">{{ $t('sizeSelect.approxSize') }}</h3>
    <b-row class="my-3">
      <b-col class="text-center">
        <div v-if="disableSmall" title="Out of Stock" class="no-stock">
          <div class="tag d-none d-lg-block">
            <img :src="require('@/assets/images/tag_size_small.svg')" alt="" />
          </div>
          <h3 class="text-light my-0 mt-lg-2 mb-lg-0 py-1 py-lg-2">
            <strong>{{ $t('sizeSelect.small.text') }}</strong> <span class="text-light d-lg-none">({{ $t('sizeSelect.small.size') }})</span>
          </h3>
          <h3 class="text-light d-none d-lg-block">{{ $t('sizeSelect.small.size') }}</h3>
          <h3 class="text-danger mt-n1 mt-lg-n2">{{ $t('sizeSelect.outOfStock') }}</h3>
        </div>
        <b-button
          v-else
          :ref="'S'"
          class="size-option"
          :aria-label="`Choose ${$t('sizeSelect.small.text')}`"
          :title="$t('sizeSelect.small.text')"
          :class="{ selected: size == 'S' }"
          @click="setSize('S')"
          @focus="setFocus('S')"
          @focusout="unsetFocus"
        >
          <span class="tag d-none d-lg-block">
            <img :src="require('@/assets/images/tag_size_small.svg')" alt="" />
          </span>
          <h3 class="text-primary my-2 mb-lg-0 py-2 pb-lg-0">
            <strong>{{ $t('sizeSelect.small.text') }}</strong> <span class="text-light d-lg-none">({{ $t('sizeSelect.small.size') }})</span>
          </h3>
          <h3 class="text-light d-none d-lg-block">{{ $t('sizeSelect.small.size') }}</h3>
        </b-button>
      </b-col>
      <b-col class="text-center">
        <div v-if="disableLarge" title="Out of Stock" class="no-stock">
          <div class="tag d-none d-lg-block">
            <img :src="require('@/assets/images/tag_size_large.svg')" alt="" />
          </div>
          <h3 class="text-light my-0 mt-lg-2 mb-lg-0 py-1 py-lg-2">
            <strong>{{ $t('sizeSelect.large.text') }}</strong> <span class="text-light d-lg-none">({{ $t('sizeSelect.large.size') }})</span>
          </h3>
          <h3 class="text-light d-none d-lg-block">{{ $t('sizeSelect.large.size') }}</h3>
          <h3 class="text-danger mt-n1 mt-lg-n2">{{ $t('sizeSelect.outOfStock') }}</h3>
        </div>
        <b-button
          v-else
          :ref="'L'"
          class="size-option"
          :title="$t('sizeSelect.large.text')"
          :aria-label="`Choose ${$t('sizeSelect.large.text')}`"
          :class="{ selected: size == 'L' }"
          @click="setSize('L')"
          @focus="setFocus('L')"
          @focusout="unsetFocus"
        >
          <span class="tag d-none d-lg-block">
            <img :src="require('@/assets/images/tag_size_large.svg')" alt="" />
          </span>
          <h3 class="text-primary my-2 mb-lg-0 py-2 pb-lg-0">
            <strong>{{ $t('sizeSelect.large.text') }}</strong> <span class="text-light d-lg-none">({{ $t('sizeSelect.large.size') }})</span>
          </h3>
          <h3 class="text-light d-none d-lg-block">{{ $t('sizeSelect.large.size') }}</h3>
        </b-button>
      </b-col>
    </b-row>
    <ValidationProvider v-slot="{ errors }" vid="p-size-select" :rules="{ required: { allowFalse: false } }" slim>
      <input id="product-style-size" v-model="value" type="text" class="d-none" hidden />
      <span v-if="errors && errors[0]" class="text-danger">{{ $t('sizeSelect.error') }}</span>
    </ValidationProvider>
  </section>
</template>

<script>
import { KeyboardNavigationMixins } from '@/mixins/keyboardNavigation';
export default {
  name: 'SizeSelect',
  mixins: [KeyboardNavigationMixins],
  props: {
    value: {
      type: String,
      required: false,
      default: '',
    },
    disableSmall: {
      type: Boolean,
      required: false,
      default: false,
    },
    disableLarge: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      size: this.value,
    };
  },
  computed: {
    navigableOptions() {
      let options = [];
      if (!this.disableSmall) {
        options.push('S');
      }
      if (!this.disableLarge) {
        options.push('L');
      }
      return options;
    },
  },
  watch: {
    value() {
      this.size = this.value;
    },
  },
  methods: {
    setSize(size) {
      if (size == this.size) {
        return;
      } else {
        this.size = size;
      }
      this.$emit('input', this.size);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@docupet/component-library/src/assets/styles/_variables';
.size-option {
  border-radius: 10px;
  border: 2px solid $dp-gray-4;
  height: auto;
  width: 100%;
  background: transparent;
  &.selected {
    border: 2px solid $dp-blue;
    background-color: rgba(204, 236, 249, 0.5);
  }
  &:hover,
  &:active,
  &:focus {
    &:not(.disabled) {
      border: 2px solid $dp-blue;
      box-shadow: 0 0 0 0.2rem $dp-light-blue;
      background-color: rgba(204, 236, 249, 0.5) !important;
    }
  }
  @media (min-width: 992px) {
    padding-top: 0.75rem;
  }
  img {
    width: 52%;
  }
}

.no-stock {
  border-radius: 10px;
  border: 2px solid white;
  height: auto;
  @media (min-width: 992px) {
    padding-top: 0.75rem;
  }
  img {
    width: 52%;
    filter: grayscale(100%);
  }
}
</style>
